import React, {
    forwardRef,
    useState,
    useImperativeHandle,
    useEffect
} from "react";
import { useTranslation } from "react-i18next";

const MarkRenderer = forwardRef((props, ref) => {
    const { t } = useTranslation();

    const [mark, setMark] = useState(props.value);
    const [cancellationMark, setCancellationMark] = useState("");

    useImperativeHandle(ref, () => ({
        refresh(params) {
            const val = params.value;
            if (val !== undefined) {
                setMark(val);
            }
            return true;
        }
    }));

    useEffect(() => {
        if (props.node?.data) {
            setCancellationMark(props.node.data.cancellationMark || "");
        }
    }, [props.node?.data]);

    const data = props.node?.data;

    const inconsistencyIcon = data?.hasInconsistency ? (
        <i
            title={t("incosistncyIconInfo")}
            className="fa fa-exclamation-circle incosistncyIconInfo"
        />
    ) : null;

    const getMarkCell = () => {
        if (cancellationMark) {
            return (
                <span className="mark-span-container">
                    <span className="cancelationMark-span">
                        {cancellationMark}
                    </span>
                    <span className="mark-span">{mark}</span>
                </span>
            );
        }

        if (mark) return mark;

        return (
            <span
                style={{
                    color: "#6c757d",
                    fontSize: 14,
                    fontStyle: "italic"
                }}
            >
                {t("notInMyData")}
            </span>
        );
    };

    const renderContent = () => {
        if (!data) return null;

        if (data.parochosStatus == 0 && data.transmissionType == 4) {
            return (
                <span className="mark-pending-container badge bg-warning">
                    {t("TransactionPending")}
                </span>
            );
        }
        if (data.parochosStatus == 0 && data.transmissionFailure == 1) {
            return (
                 <span className="mark-pending-container badge bg-info">
                    {t("transmissionUknown")}
                </span>
            );
        }
        else if (data.parochosStatus == 2 && data.transmissionFailure == 2) {
            return (
                <span
                    title={data.parochosErrorMessage}
                    className="parochos-error badge bg-danger"
                >
                    TransmissionFailure
                </span>
            );
        }
        else if (data.parochosStatus == 2) {
            return (
                <span
                    title={data.parochosErrorMessage}
                    className="parochos-error badge bg-danger"
                >
                    Error
                </span>
            );
        }

        return <span>{getMarkCell()}</span>;
    };

    return (
        <>
            {inconsistencyIcon}
            {renderContent()}
        </>
    );
});

export default MarkRenderer;